import { ReactGAImplementation } from "react-ga4";

class Analytics extends ReactGAImplementation {
  private static instance: Analytics;

  public static getInstance(): Analytics {
    return this.instance || (this.instance = new this());
  }
}

const analyticsInstance: Analytics = Analytics.getInstance();

export { analyticsInstance as GA };
